import React, {useState} from 'react';
import styles from './TextfieldQuarter.module.css';
import moment from 'moment';
import CalendarQuarter from "../CalendarQuarter/CalendarQuarter";

export interface TextfieldDateProps {
    title: string;
    value: Date;
    setValue: (value: Date | undefined) => void;
    alignCalendar?: 'left' | 'right';
}

const TextfieldQuarter = ({
                            title,
                            value,
                            setValue,
                            alignCalendar = 'left',
                        }: TextfieldDateProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleSetValue = (value: Date | undefined) => {
        setValue(value);
        setIsOpen(false);
    };

    return (
        <div>
            <div className={styles.wrapper} onClick={() => setIsOpen(!isOpen)}>
                <span>Q{moment(value).format('Q YYYY')}</span>
                <div className={`${styles.icon} ${styles.iconCalendar}`}/>
                {isOpen && (
                    <>
                        <div className={styles.backdrop}/>
                        <div className={`${styles.calendar} ${alignCalendar === 'left' ? styles.calendarLeft : styles.calendarRight}`}>
                            <CalendarQuarter
                                title={title}
                                value={value}
                                setValue={handleSetValue}
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default TextfieldQuarter;
